import { Components, Theme } from '@mui/material/styles';

export const muiButtonBaseOverride: Components<Omit<Theme, 'components'>>['MuiButtonBase'] = {
  defaultProps: {
    disableRipple: true
  },
  styleOverrides: {
    root: {
      '&.MuiButton-contained:hover': {
        outline: '2px solid #000'
      },
      '&.Mui-focusVisible': {
        outline: '2px solid #000'
      }
    }
  }
};
